import React from "react";
import * as styles from "./NewLoader.module.scss";
import { useSiteQuery } from "../../hooks";

interface LoadingSpinnerProps {
  overLay?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  overLay = true,
}) => {

  const { loaderText } = useSiteQuery();

  return (
    <div className={overLay ? styles.loadingOverlay : styles.no}>
      <div className={styles.loaderCard}>
        <p className={`global-spacing-bottom ${styles.loaderMessage}`}>
          {loaderText}
        </p>

        <div className={styles.loadingDots} aria-hidden="true">
          <span className={`${styles.dot} ${styles.dotOne}`} />
          <span className={`${styles.dot} ${styles.dotTwo}`} />
          <span className={`${styles.dot} ${styles.dotThree}`} />
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
